import React from 'react';
import {
  LoginPromptInfoBox,
  type TInfoBoxContent,
  determineInfoBoxContent,
} from '@secretescapes/cauldron';
import { InfoBoxSize } from '@secretescapes/falcon';
import { useAppState } from '@utils/useAppState';
import { useApplicationState } from '@utils/useApplicationState';

export const CreditsStaffDiscountInfoBox = () => {
  const { isSemiLoggedUser, isStaffUser, hasCredits, onOpenPasswordLoginForm } = useAppState();
  const { isMobile } = useApplicationState();
  const showStaffDiscountPrompt = isSemiLoggedUser && isStaffUser;
  const [infoBox, setInfoBox] = React.useState<TInfoBoxContent>(
    determineInfoBoxContent(showStaffDiscountPrompt, hasCredits)
  );

  if (!infoBox || !isSemiLoggedUser) {
    return null;
  }

  return (
    <LoginPromptInfoBox
      setInfoBox={setInfoBox}
      infoBox={infoBox}
      row={!isMobile}
      size={isMobile ? InfoBoxSize.extraSmall : InfoBoxSize.small}
      onLoginAction={onOpenPasswordLoginForm}
    />
  );
};
